
import { BusinessUnitMetadataBase } from './business-unit.metadata.base';


export class BusinessUnitMetadata extends BusinessUnitMetadataBase {
  constructor() {
    super();
  }
}

export const BUSINESS_UNIT_METADATA: BusinessUnitMetadata = new BusinessUnitMetadata();


